export default "__VITE_ASSET__BKpkv63V__"